// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import LOYALTY_PLACE_REWARDS_CONSTANTS from '../LoyaltyPlaceRewards.constants';

const initialState = fromJS({
  loyaltyTierBenefits: null,
  loyaltyTierBenefitsJson: null,
  loadingLoyaltyTierBenefits: false,
  loyaltyTierBenefitsJsonError: null,
  loyaltyTierBenefitJsonTimestamp: null,
  earlyAccessProducts: null,
});

const LoyaltyPlaceRewardsReducer = (state = initialState, action) => {
  switch (action?.type) {
    case LOYALTY_PLACE_REWARDS_CONSTANTS?.SET_LOYALTY_TIER_BENEFITS:
      return state.set('loyaltyTierBenefits', action.payload);

    case LOYALTY_PLACE_REWARDS_CONSTANTS.FETCH_LOYALTY_BENEFIT_JSON_REQUEST:
      return state
        .set('loadingLoyaltyTierBenefits', true)
        .set('loyaltyTierBenefitsJsonError', null);

    case LOYALTY_PLACE_REWARDS_CONSTANTS.FETCH_LOYALTY_BENEFIT_JSON_SUCCESS:
      return state
        .set('loyaltyTierBenefitsJson', action.payload)
        .set('loyaltyTierBenefitJsonTimestamp', action.payload.timestamp)
        .set('loadingLoyaltyTierBenefits', false)
        .set('loyaltyTierBenefitsJsonError', null);

    case LOYALTY_PLACE_REWARDS_CONSTANTS.FETCH_LOYALTY_BENEFIT_JSON_FAILURE:
      return state
        .set('loyaltyTierBenefitsJsonError', action.payload)
        .set('loadingLoyaltyTierBenefits', false);
    case LOYALTY_PLACE_REWARDS_CONSTANTS.SET_MODULE_X_CONTENT:
      return state.set('tierBenefitsModuleContent', action.payload);
    case LOYALTY_PLACE_REWARDS_CONSTANTS.SET_EA_PRODUCTS:
      return state.set('earlyAccessProducts', action.payload);
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default LoyaltyPlaceRewardsReducer;
